<template>
    <div :class="['app-layout', 'app-content', {home: isHomePage}]">
        <app-header></app-header>
        <div :class="['notIndex', {'guest-page': !pageAuth}] ">
            <main>
                <router-view></router-view>
            </main>
        </div>
        <footer-menu :isAuth="isAuth"></footer-menu>
        <app-footer></app-footer>
    </div>
</template>


<script>
    import AuthUtil from '../utils/AuthUtil';
    import AppHeader from '../components/AppHeader/AppHeader.vue';
    import AppFooter from '../components/AppFooter/AppFooter.vue';
    import UserService from "../services/UserService";
    import FooterMenu from '../components/FooterMenu/FooterMenu.vue';

    export default {
        name: 'app-layout',

        components: {
            AppHeader,
            AppFooter,
            FooterMenu
        },

        data() {
            return {
                childChangePassword: true,
                isAuth: false,
                pageAuth: false,
                isHomePage: false
            }
        },

        async created() {
            this.isAuth = AuthUtil.isAuth();
            this.pageAuth = this.$route.meta.auth;
            this.isHomePage = this.$route.name === 'home';

            if (this.pageAuth) {
                await this.fetchUserFrontendData();
            }

            //javascript追加
            let scripts = ['/assets/js/jquery-3.4.1.min.js', '/assets/js/slick.min.js', '/assets/js/modernizr.min.js', '/assets/js/wow.min.js', '/assets/js/common.js'];
            let len = scripts.length;
            let i = 0;

            (function appendScript() {
                if (scripts[i] != undefined) {
                    let script = document.createElement('script');
                    script.src = scripts[i];
                    document.body.appendChild(script);
            
                    if (i++ < len) {
                        script.onload = appendScript;
                    }
                }
            })();
        },

        mounted() {
        },

        watch: {
            $route (to, from){
                this.pageAuth = to.meta.auth;
            }
        },

        methods: {
            async fetchUserFrontendData() {
                const user = (await UserService.getUserFrontendData(true)).data;
                if (user.is_child && !user.changed_password) {
                    this.$router.push('/child/change-password');
                }
            }
        }
    }
</script>








